import { LandingPageFields } from "./LandingPageFields";
import style from "./style.module.css";

interface VersionTemplateMetadataSectionProps {
  templateName: string;
  clientName: string | null;
  nextVersion: number;
}

export function VersionTemplateMetadataSection({
  templateName,
  clientName,
  nextVersion,
}: VersionTemplateMetadataSectionProps) {
  return (
    <>
      <dl className={style.metadataList}>
        <dt>Assessment Template Name</dt>
        <dd>{templateName}</dd>

        <dt>Version Number</dt>
        <dd>{nextVersion}</dd>

        <dt>Client</dt>
        <dd>{clientName ?? "All Clients"}</dd>
      </dl>
      <LandingPageFields />
    </>
  );
}
